import { createSelector } from "@reduxjs/toolkit";
import {
  selectSpecifiedArticlesListTypes,
  selectSpecifiedArticlesResponsibilities,
  selectDrofusOccurrenceValidationListType,
  selectDrofusOccurrenceValidationResponsibility,
  selectDrofusOccurrenceValidationFilterMode,
} from "../DesignTab/ModuleBars/DrofusOccurrenceValidationBarSelectors";
export const selectOccurrencePanelFilter = createSelector(
  [
    selectSpecifiedArticlesListTypes,
    selectSpecifiedArticlesResponsibilities,
    selectDrofusOccurrenceValidationListType,
    selectDrofusOccurrenceValidationResponsibility,
    selectDrofusOccurrenceValidationFilterMode,
  ],
  (listTypes, responsibilities, activeListType, activeResponsibility, filterMode) => {
    const listTypeOptions = [
      { value: null, label: "Alle lister" },
      ...listTypes.map((listType) => ({ value: listType, label: listType })),
    ];
    const responsibilityOptions = [
      { value: null, label: "Alle ansvar" },
      ...responsibilities.map((responsibility) => ({
        value: responsibility,
        label: responsibility,
      })),
    ];
    const activeFilterOptions = filterMode === "listType" ? listTypeOptions : responsibilityOptions;
    const activeFilterValue = filterMode === "listType" ? activeListType : activeResponsibility;
    const activeFilterLabel = filterMode === "listType" ? "Liste" : "Ansvar";
    const activeFilterEmptyLabel = filterMode === "listType" ? "Alle lister" : "Alle ansvar";
    const activeFilterTooltip =
      filterMode === "listType"
        ? "Avgrenser valideringen til forekomster som ligger på valgt dRofus-liste."
        : "Avgrenser valideringen til forekomster med valgt ansvarskode.";
    const activeFilterDisabled =
      filterMode === "listType" ? listTypeOptions.length <= 1 : responsibilityOptions.length <= 1;

    return {
      filterMode,
      activeFilterOptions,
      activeFilterValue,
      activeFilterLabel,
      activeFilterEmptyLabel,
      activeFilterTooltip,
      activeFilterDisabled,
    };
  }
);
